<template>
    <div class="col-md-9 list-img-div-large">
        <img class="list-img-large" :src="getItemImgSrc"/>
        <p class="list-text-large text-center" unselectable="on" onselectstart="return false;">{{ getItemImgTitle }}</p>
    </div>
</template>


<script>

const gcs_host = "https://storage.googleapis.com/sb_web_site/";

export default {
    name: 'ListItem',
    props:{
                'itemImgSrc': Object,
                'itemTitle': String,
        },
    data(){
            return {
                listObj:null,
                listTitle:"",
                listImgURL:""
            }
        },
    methods: {
        resolve_img_url: function (path) {
            let images = require.context('../static/images/', false, /\.png$|\.jpg$/)
            return images("./"+path)
        }
    },
    computed:{
            customStyle(){
                    return {
                        //'background': "url(require(" + this.imgSrc + "))",
                     }
            },
            getItemImgTitle(){
                return this.itemTitle;
            },
            getItemImgSrc(){
                if(this.itemImgSrc != null && this.itemImgSrc.fileName != undefined){
                    //console.log(gcs_host + this.itemImgSrc.fileName);
                    return gcs_host + this.itemImgSrc.fileName;
                }else{
                    return require(`@/static/images/${this.itemImgSrc}`);
                }
                
            }
    },
    mounted() {

        if(this.itemImgSrc != null){
            // console.log(this.itemImgSrc.fileName);
            // let picDataObj = this.itemImgSrc.pics.picData;
            // let picDataNum = Object.keys(picDataObj).length;
            // let firstKey = Object.keys(picDataObj)[0];
            // let picObj = picDataObj[firstKey];
            // this.listImgURL = gcs_host + picObj.fileName;
            //console.log(picTitle)
            
            

        }
        


    }
}
</script>

<style lang="sass" scoped>
  @import '../assets/listitemlarge.sass'
</style>
